export const RESET_JOIN_STATE = 'RESET_JOIN_STATE';

export function resetJoinState(){
    return{
        type: RESET_JOIN_STATE,
    }
}